import React from 'react';

function RingtoneCard({ operator, onSelect, onEdit, onDelete, onInactivate, onActivate, t }) {
  const isActive = operator.status === 'Active';

  const handleEditClick = (e) => {
    e.stopPropagation();
    if (onEdit) onEdit(operator);
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    if (onDelete) onDelete(operator);
  };

  const handleInactivateClick = (e) => {
    e.stopPropagation();
    if (onInactivate) onInactivate(operator);
  };

  const handleActivateClick = (e) => {
    e.stopPropagation();
    if (onActivate) onActivate(operator);
  };

  return (
    <div className="operator-ringtone-card" onClick={() => onSelect && onSelect(operator)}>
      {/* Left Panel */}
      <div className="operator-ringtone-card-left">
        <div className="operator-ringtone-card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' }}>
          <div className="logo-container" style={{ width: '48px', height: '48px', borderRadius: '8px', overflow: 'hidden', border: '1px solid var(--border-color)', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f8fafc' }}>
            {operator.logo ? (
              <img 
                src={operator.logo} 
                alt={operator.name} 
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
            ) : (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" strokeWidth="2.5">
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                <path d="M13.73 21a2 2 0 0 1-3.46 0" />
              </svg>
            )}
          </div>
          
          <div className="card-actions-wrapper" style={{ display: 'flex', gap: '8px' }}>
            {isActive ? (
              <>
                {/* Edit Button — Active only, shown if onEdit provided */}
                {onEdit && (
                  <button 
                    type="button" 
                    className="operator-ringtone-card-edit-btn" 
                    onClick={handleEditClick}
                    title="Edit Operator"
                    style={{ padding: '6px', borderRadius: '6px', border: 'none', background: '#f1f5f9', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#475569' }}
                  >
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                      <path d="M18.5 2.5a2.121 2.121 0 1 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                    </svg>
                  </button>
                )}
                {/* Inactive Button — Active only, shown if onInactivate provided */}
                {onInactivate && (
                  <button 
                    type="button" 
                    onClick={handleInactivateClick}
                    title="Make Inactive"
                    style={{ padding: '6px', borderRadius: '6px', border: 'none', background: '#fef3c7', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#d97706' }}
                  >
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="8" y1="12" x2="16" y2="12" />
                    </svg>
                  </button>
                )}
              </>
            ) : (
              <>
                {/* Activate Button — Inactive only, shown if onActivate provided */}
                {onActivate && (
                  <button 
                    type="button" 
                    onClick={handleActivateClick}
                    title="Activate Operator"
                    style={{ padding: '6px', borderRadius: '6px', border: 'none', background: '#dcfce7', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#16a34a' }}
                  >
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                      <polyline points="22 4 12 14.01 9 11.01" />
                    </svg>
                  </button>
                )}
                {/* Delete Button — Inactive only, shown if onDelete provided */}
                {onDelete && (
                  <button 
                    type="button" 
                    onClick={handleDeleteClick}
                    title="Delete Operator"
                    style={{ padding: '6px', borderRadius: '6px', border: 'none', background: '#fee2e2', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ef4444' }}
                  >
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <polyline points="3 6 5 6 21 6" />
                      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                    </svg>
                  </button>
                )}
              </>
            )}
          </div>
        </div>
        <div className="operator-ringtone-card-body" style={{ marginTop: '12px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <h3 className="ringtone-operator-name" style={{ fontSize: '15px', fontWeight: '700', color: 'var(--text-main)' }}>
              {operator.name}
            </h3>
            <span className={`status-pill ${isActive ? 'active' : 'inactive'}`} style={{ fontSize: '11px', padding: '2px 8px' }}>
              <span className="status-dot"></span>
              {operator.status}
            </span>
          </div>
        </div>
      </div>

      {/* Right Panel */}
      <div className="operator-ringtone-card-right">
        <div className="song-count-container">
          <span className="song-count-label">{t('ringtone.songCount')}</span>
          <span className="song-count-number" style={{ display: 'block', fontSize: '15px', fontWeight: '700', color: 'var(--text-main)', marginTop: '4px' }}>
            {operator.songCount} {operator.songCount === 1 ? 'Song' : 'Songs'}
          </span>
        </div>
        <div className="recode-labels-container">
          <div className="avatar-stack mini">
            <div className="avatar-stacked gray-dot"></div>
            <div className="avatar-stacked gray-dot"></div>
            <div className="avatar-stacked gray-dot"></div>
          </div>
          <span className="recode-labels-pill">{t('ringtone.recodeLabels')}</span>
        </div>
      </div>
    </div>
  );
}

export default RingtoneCard;
